var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-cpf-dia" },
    [
      _c(
        "van-dialog",
        {
          attrs: { showConfirmButton: false, closeOnClickOverlay: "true" },
          on: { close: _vm.close },
          model: {
            value: _vm.showCpfDia,
            callback: function ($$v) {
              _vm.showCpfDia = $$v
            },
            expression: "showCpfDia",
          },
        },
        [
          _c("div", { staticClass: "dialog" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(" " + _vm._s(_vm.$t("lang.pay.cpfTip")) + " "),
            ]),
            _c("div", { staticClass: "cpf-input" }, [
              _c("span", { staticClass: "tit" }, [_vm._v("CPF：")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formattedInputCPF,
                    expression: "formattedInputCPF",
                  },
                ],
                staticClass: "input",
                attrs: { placeholder: "000.000.000-00", type: "text" },
                domProps: { value: _vm.formattedInputCPF },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.formattedInputCPF = $event.target.value
                    },
                    _vm.formatInput,
                  ],
                },
              }),
            ]),
            _c("div", { staticClass: "btn" }, [
              _c(
                "span",
                {
                  staticClass: "confirm-think",
                  on: { click: _vm.handleThinK },
                },
                [_vm._v(_vm._s(_vm.$t("lang.think")))]
              ),
              _c(
                "span",
                {
                  staticClass: "confirm-btn",
                  class: {
                    activeConfirmBtn:
                      _vm.formattedInputCPF &&
                      _vm.formattedInputCPF.length >= 14,
                  },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v(_vm._s(_vm.$t("lang.confirm")))]
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }